export const microlearning = {
  ref: 'microlearning',
  version: '1'
};

export const learner = {
  ref: 'learner',
  version: '1'
};
